import {
  CP_PORTAL_MODULE_SLUGS,
  cpPortalModuleBySlug,
} from '../config/cp-portal-modules.config';

/** Maps first URL segment (or system/*) to canonical portal module slug. */
const CP_ROUTE_PREFIX_TO_MODULE: Record<string, string> = {
  'property-bookings': 'bookings',
  'template-config': 'integrations',
  'social-hub': 'integrations',
};

export function resolveCpPortalModuleSlugFromUrl(url: string): string | null {
  const path = url.split('?')[0].split('#')[0];
  const segments = path.replace(/^\//, '').split('/').filter(Boolean);
  if (segments.length === 0) {
    return null;
  }

  if (segments[0] === 'system' && segments[1]) {
    if (segments[1] === 'recycle-bin') {
      return 'system';
    }
    if (segments[1] === 'companies') {
      return 'companies';
    }
    if (segments[1] === 'audit-logs') {
      return 'audit-logs';
    }
  }

  const first = segments[0];
  const mapped = CP_ROUTE_PREFIX_TO_MODULE[first];
  if (mapped) {
    return mapped;
  }
  if ((CP_PORTAL_MODULE_SLUGS as readonly string[]).includes(first)) {
    return first;
  }
  return null;
}

export function cpPortalModuleLabelFromSlug(slug: string | null | undefined): string | null {
  if (!slug?.trim()) {
    return null;
  }
  return cpPortalModuleBySlug(slug.trim())?.label ?? null;
}

/** Routes that must stay reachable without plan module entitlements. */
export function isCpSubscriptionGuardExemptUrl(url: string): boolean {
  const path = url.split('?')[0].split('#')[0];
  return (
    path === '/subscription-access-denied' ||
    path === '/access-denied' ||
    path.startsWith('/my-profile') ||
    path === '/dashboard' ||
    path.startsWith('/dashboard/')
  );
}
